import type { PropsWithChildren } from 'react';
import { AccordionContext } from './AccordionContext';
import type { AccordionOutputs } from './useAccordion';

export type AccordionProps = PropsWithChildren<AccordionOutputs>;

export const Accordion = ({ children, ...accordion }: AccordionProps) => {
  return <AccordionContext.Provider value={accordion}>{children}</AccordionContext.Provider>;
};
